import React from "react";
import {
  MDBContainer,
  MDBInput,
  MDBCol,
  MDBRow,
  MDBSwitch,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBIcon,
} from "mdb-react-ui-kit";
import { Form, Alert } from "react-bootstrap";

import "../sso-management.css";
import "./UserNewModal.css";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { MfmImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmImageUploader/MfmImageUploader";
import { DualPicklist } from "Projects/CC_cubi_clan_project/GlobalComponents/DualPicklist/DualPicklist";
import { validatePasswordStrength } from "Projects/SSO_single_sign_on_project/Utils/PasswordUtils";

export class UserNewModal extends React.Component {
  constructor(props) {
    super(props);

    let dataDefault = {
      IDUsuario: null,
      apodo: "",
      password: "",
      email: "",
      nombre: "",
      apellido: "",
      telefono: "",
      activo: 0,
      userImg: "",
      imageUuid: "",
    };

    this.state = {
      showUserNewModal: this.props.showUserNewModal,
      alertData: { show: false },
      appsData: [],
      data: dataDefault,
      enabled: false,
      selectedApp: "",
      appPermisoList: [],
      permisoListAvaiable: [],
      permisoListSelected: [],
      filaSeleccionadaAdd: null,
      filaSeleccionadaRemove: null,
      mapAppPermisosSelected: {},
      // Groups
      allGrupos: [],
      gruposAvailable: [],
      gruposSelected: [],
      filaGrupoAdd: null,
      filaGrupoRemove: null,
      showPassword: false,
      passwordError: "",
    };
  }

  componentDidMount() {
    this.getApps();
    this.scrollModalToTop();
  }

  scrollModalToTop() {
    setTimeout(() => {
      const el = document.querySelector('.modal.show');
      if (el) el.scrollTop = 0;
    }, 150);
  }

  getApps() {
    this.props.onLoading(true);

    doFetch("SSO", "getAllAplicaciones", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ selectedApp: data.DATA[0].IDAplicacion });
        this.setState({ appsData: data.DATA });
        this.fillPermisos(data.DATA[0].IDAplicacion);
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  async fillPermisos(selectedApp) {
    let appPermisoList = await this.getAppPermisions(selectedApp);
    let userAppPermisos = await this.getUserAppPermisions(selectedApp);

    let permisoListAvaiable = appPermisoList.filter(
      (appPer) =>
        !userAppPermisos.find(
          (userPer) => userPer.value.IDPermiso === appPer.value.IDPermiso
        )
    );

    appPermisoList.sort((a, b) => this.permisosCompare(a, b));
    userAppPermisos.sort((a, b) => this.permisosCompare(a, b));
    permisoListAvaiable.sort((a, b) => this.permisosCompare(a, b));

    let mapAppPermisosSelected = this.state.mapAppPermisosSelected;
    mapAppPermisosSelected[selectedApp] = userAppPermisos;

    this.setState({ appPermisoList: appPermisoList });
    this.setState({ permisoListAvaiable: permisoListAvaiable });
    this.setState({ permisoListSelected: userAppPermisos });
    this.setState({ mapAppPermisosSelected: mapAppPermisosSelected });
  }

  async getAppPermisions(selectedApp) {
    let permisosList = [];
    if (selectedApp) {
      this.props.onLoading(true);

      let requestOptions = {
        method: "GET",
      };

      let method = "getAppPermisions?IDAplicacion=" + selectedApp;

      await doFetch("SSO", method, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          permisosList = [];
          for (let dat of data.DATA) {
            permisosList.push({ label: dat.nombre, value: dat });
          }
        })
        .catch((error) => {
          console.error(
            "Error al obtener datos:",
            JSON.stringify(error, null, 2)
          );
        })
        .finally(() => {
          this.props.onLoading(false);
        });
    }
    return permisosList;
  }

  async getUserAppPermisions(selectedApp) {
    let permisosList = [];
    if (selectedApp) {
      if (
        !Object.keys(this.state.mapAppPermisosSelected).includes(selectedApp)
      ) {
        permisosList = [];
      } else {
        permisosList = this.state.mapAppPermisosSelected[selectedApp];
      }
    }
    return permisosList;
  }

  closeModal() {
    this.props.onCloseModal();
  }

  showAlert(alertData) {
    alertData.show = true;
    this.setState({ alertData: alertData });
  }

  closeAlert() {
    this.setState({ alertData: { show: false } });
  }

  handleChange(event) {
    let data = this.state.data;

    switch (event.target.id) {
      case "app":
        this.setState({ selectedApp: event.target.value });
        this.fillPermisos(event.target.value);
        this.loadGrupos(event.target.value);
        break;
      case "enabled":
        data["activo"] = this.state.enabled ? 0 : 1;
        this.setState(data);
        this.setState({ enabled: !this.state.enabled });
        break;
      default:
        data[event.target.id] = event.target.value;
        this.setState(data);
        break;
    }
  }

  handleAddButtonClick(index, element) {
    this.setState({ filaSeleccionadaAdd: index });
  }

  handleRemoveButtonClick(index, element) {
    this.setState({ filaSeleccionadaRemove: index });
  }

  handleAddButtonDoubleClick(index, element) {
    if (index != null && element != null) {
      let permisoList = this.state.permisoListAvaiable;
      permisoList.splice(index, 1);

      let permisoListSelected = this.state.permisoListSelected;
      permisoListSelected.push(element);

      permisoListSelected.sort((a, b) => this.permisosCompare(a, b));

      let mapAppPermisosSelected = this.state.mapAppPermisosSelected;
      mapAppPermisosSelected[this.state.selectedApp] = permisoListSelected;

      this.setState({
        permisoListAvaiable: permisoList,
        filaSeleccionadaAdd: null,
      });
      this.setState({ permisoListSelected: permisoListSelected });
      this.setState({ mapAppPermisosSelected: mapAppPermisosSelected });
    }
  }

  handleRemoveButtonDoubleClick(index, element) {
    if (index != null && element != null) {
      let permisoList = this.state.permisoListSelected;
      permisoList.splice(index, 1);

      let permisoListAvaiable = this.state.appPermisoList.filter(
        (appPer) =>
          !permisoList.find(
            (userPer) => userPer.value.IDPermiso === appPer.value.IDPermiso
          )
      );

      permisoListAvaiable.sort((a, b) => this.permisosCompare(a, b));

      let mapAppPermisosSelected = this.state.mapAppPermisosSelected;
      mapAppPermisosSelected[this.state.selectedApp] = permisoList;

      this.setState({
        permisoListSelected: permisoList,
        filaSeleccionadaRemove: null,
      });
      this.setState({ permisoListAvaiable: permisoListAvaiable });
      this.setState({ mapAppPermisosSelected: mapAppPermisosSelected });
    }
  }

  async doSave(event) {
    event.preventDefault();

    if (!this.state.data.apodo || !this.state.data.apodo.trim()) {
      this.showAlert({ title: "Error", message: "El nombre de usuario es obligatorio" });
      return;
    }

    const passwordError = validatePasswordStrength(this.state.data.password);
    if (passwordError) {
      this.setState({ passwordError });
      return;
    }

    if (this.state.data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.data.email)) {
      this.showAlert({ title: "Error", message: "El email no tiene un formato válido" });
      return;
    }

    let res = await this.registerUser();
    res = res ? await this.updateUserAppPermissions(res) : res;
    res = res ? await this.updateUserGroups(res) : res;

    if (res) {
      this.props.onCloseModal();
    }
  }

  async registerUser() {
    let result = null;

    this.props.onLoading(true);

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.state.data),
    };

    this.props.onLoading(true);

    await doFetch("SSO", "register", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = data.DATA;
        } else {
          this.showAlert({
            title: "Excepción",
            message:
              "No se ha podido registrar el usuario:" +
              JSON.stringify(data, null, 2),
            variant: "danger",
          });
          console.error(
            "No se ha podido registrar el usuario:",
            JSON.stringify(data, null, 2)
          );
        }
      })
      .catch((error) => {
        this.showAlert({
          title: "Excepción",
          message:
            "Se ha producido una excepción:" + JSON.stringify(error, null, 2),
          variant: "danger",
        });
        console.error(
          "Se ha producido una excepción:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  async updateUserAppPermissions(userData) {
    let result = false;

    if (!userData || !userData.IDUsuario) {
      console.error(
        "Error al asignar permisos, no se ha podido recuperar el Id del usuario generado."
      );
      return false;
    }

    this.props.onLoading(true);

    let permisoList = [];
    for (let [app, permisos] of Object.entries(
      this.state.mapAppPermisosSelected
    )) {
      for (let permiso of permisos) {
        permisoList.push({
          IDAplicacionFK: { IDAplicacion: app },
          IDUsuarioFK: { IDUsuario: userData.IDUsuario },
          IDPermisoFK: { IDPermiso: permiso.value.IDPermiso },
        });
      }
    }

    if (permisoList.length === 0) {
      return true;
    }

    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(permisoList),
    };

    this.props.onLoading(true);

    await doFetch("SSO", "updateUserAppPermissions", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  permisosCompare(a, b) {
    if (a.value.nombre > b.value.nombre) {
      return 1;
    }
    if (a.value.nombre < b.value.nombre) {
      return -1;
    }
    return 0;
  }

  async loadGrupos(selectedApp) {
    if (!selectedApp) {
      this.setState({ allGrupos: [], gruposAvailable: [], gruposSelected: [] });
      return;
    }

    this.props.onLoading(true);

    let allGrupos = [];
    let gruposMethod = "getAllGrupos?IDAplicacion=" + selectedApp;

    await doFetch("SSO", gruposMethod, null)
      .then((response) => response.json())
      .then((data) => {
        if (data.DATA) {
          allGrupos = data.DATA.map((g) => ({
            label: g.nombre,
            value: g,
          }));
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    let gruposAvailable = allGrupos.filter(
      (g) => !this.state.gruposSelected.find((sg) => sg.value.IDGrupo === g.value.IDGrupo)
    );

    this.setState({
      allGrupos: allGrupos,
      gruposAvailable: gruposAvailable,
    });
  }

  handleGrupoAddClick(index) {
    this.setState({ filaGrupoAdd: index });
  }

  handleGrupoRemoveClick(index) {
    this.setState({ filaGrupoRemove: index });
  }

  handleGrupoAddDoubleClick(index, element) {
    if (index != null && element != null) {
      let gruposAvailable = [...this.state.gruposAvailable];
      gruposAvailable.splice(index, 1);

      let gruposSelected = [...this.state.gruposSelected];
      gruposSelected.push(element);

      this.setState({
        gruposAvailable: gruposAvailable,
        gruposSelected: gruposSelected,
        filaGrupoAdd: null,
      });
    }
  }

  handleGrupoRemoveDoubleClick(index, element) {
    if (index != null && element != null) {
      let gruposSelected = [...this.state.gruposSelected];
      gruposSelected.splice(index, 1);

      let gruposAvailable = this.state.allGrupos.filter(
        (g) => !gruposSelected.find((sg) => sg.value.IDGrupo === g.value.IDGrupo)
      );

      this.setState({
        gruposAvailable: gruposAvailable,
        gruposSelected: gruposSelected,
        filaGrupoRemove: null,
      });
    }
  }

  async updateUserGroups(userId) {
    if (this.state.gruposSelected.length === 0) {
      return true;
    }

    let result = false;
    this.props.onLoading(true);

    let gruposList = this.state.gruposSelected.map((g) => ({
      IDGrupoFK: { IDGrupo: g.value.IDGrupo },
    }));

    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(gruposList),
    };

    let method = "updateUserGrupos?IDUsuario=" + userId;

    await doFetch("SSO", method, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  setShow(event) {
    if (this.state.showUserNewModal !== event) {
      if (!event) {
        this.props.onCloseModal();
      }
    }
  }

  handleImageChange(result) {
    let data = this.state.data;
    data.imageUuid = result.uuid;
    this.setState({ data });
  }

  handleImageDelete() {
    let data = this.state.data;
    data.imageUuid = "";
    this.setState({ data });
  }

  render() {
    return (
      <>
        <MDBModal
          show={this.state.showUserNewModal}
          setShow={(event) => this.setShow(event)}
          tabIndex="-1"
        >
          <MDBModalDialog size="xl">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle style={{ fontSize: "1.05rem" }}>
                  <MDBIcon fas icon="user-plus" className="me-2" />
                  Nuevo usuario
                </MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={() => this.closeModal()}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <Alert
                  show={this.state.alertData.show}
                  variant={this.state.alertData.variant}
                  onClose={() => this.closeAlert()}
                  dismissible
                >
                  <Alert.Heading>{this.state.alertData.title}</Alert.Heading>
                  <p>{this.state.alertData.message}</p>
                </Alert>
                <MDBContainer className="sso-modal-form">
                  {/* ── Datos del usuario ── */}
                  <h6 className="sso-section-title">
                    <MDBIcon fas icon="id-card" className="me-2" />
                    Datos del usuario
                  </h6>
                  <MDBRow>
                    <MDBCol md="3">
                      <MfmImageUploader
                        uuid={this.state.data.imageUuid}
                        img={this.state.data.userImg}
                        appCode="SSO"
                        mediaType="image"
                        onUpload={(result) => this.handleImageChange(result)}
                        onDelete={() => this.handleImageDelete()}
                      />
                    </MDBCol>
                    <MDBCol md="9">
                      <MDBRow>
                        <MDBCol md="8">
                          <MDBInput
                            className="mb-3"
                            type="text"
                            id="apodo"
                            label="Nombre de usuario"
                            value={this.state.data.apodo}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                        <MDBCol md="4" className="d-flex align-items-center">
                          <MDBSwitch
                            id="enabled"
                            label="Activo"
                            checked={this.state.enabled}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol md="6">
                          <MDBInput
                            className="mb-3"
                            type={this.state.showPassword ? "text" : "password"}
                            id="password"
                            label="Contraseña"
                            value={this.state.data.password}
                            onChange={(event) => {
                              this.handleChange(event);
                              this.setState({ passwordError: validatePasswordStrength(event.target.value) });
                            }}
                          />
                          {this.state.passwordError && (
                            <p className="text-danger mb-2" style={{ fontSize: "0.78rem" }}>{this.state.passwordError}</p>
                          )}
                        </MDBCol>
                        <MDBCol md="6" className="d-flex align-items-start pt-1">
                          <MDBBtn
                            type="button"
                            color="link"
                            size="sm"
                            className="p-0 text-decoration-none"
                            onClick={() => this.setState(prev => ({ showPassword: !prev.showPassword }))}
                          >
                            <MDBIcon fas icon={this.state.showPassword ? "eye-slash" : "eye"} className="me-1" />
                            {this.state.showPassword ? "Ocultar" : "Mostrar"}
                          </MDBBtn>
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol md="6">
                          <MDBInput
                            className="mb-3"
                            type="text"
                            id="email"
                            label="Email"
                            value={this.state.data.email}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                        <MDBCol md="6">
                          <MDBInput
                            className="mb-3"
                            type="text"
                            id="telefono"
                            label="Teléfono"
                            value={this.state.data.telefono}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol md="6">
                          <MDBInput
                            className="mb-3"
                            type="text"
                            id="nombre"
                            label="Nombre"
                            value={this.state.data.nombre}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                        <MDBCol md="6">
                          <MDBInput
                            className="mb-3"
                            type="text"
                            id="apellido"
                            label="Apellidos"
                            value={this.state.data.apellido}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                      </MDBRow>
                    </MDBCol>
                  </MDBRow>

                  {/* ── Grupos ── */}
                  <h6 className="sso-section-title">
                    <MDBIcon fas icon="users" className="me-2" />
                    Grupos
                  </h6>
                  <DualPicklist
                    available={this.state.gruposAvailable}
                    selected={this.state.gruposSelected}
                    titleLeft="Disponibles"
                    titleRight="Asignados"
                    height="200px"
                    onAdd={(item) => this.handleGrupoAddDoubleClick(
                      this.state.gruposAvailable.indexOf(item), item
                    )}
                    onRemove={(item) => this.handleGrupoRemoveDoubleClick(
                      this.state.gruposSelected.indexOf(item), item
                    )}
                  />

                  {/* ── Permisos específicos ── */}
                  <h6 className="sso-section-title mt-3">
                    <MDBIcon fas icon="key" className="me-2" />
                    Permisos específicos
                  </h6>
                  <MDBRow className="mb-3">
                    <MDBCol md="5">
                      <Form.Label htmlFor="app" style={{ fontSize: "0.82rem" }}>Aplicación</Form.Label>
                      <Form.Select
                        size="sm"
                        id="app"
                        value={this.state.selectedApp}
                        onChange={(event) => this.handleChange(event)}
                      >
                        {this.state.appsData.map((element, index) => (
                          <option key={index} value={element.IDAplicacion}>
                            {element.nombre + " — " + element.titulo}
                          </option>
                        ))}
                      </Form.Select>
                    </MDBCol>
                  </MDBRow>
                  <DualPicklist
                    available={this.state.permisoListAvaiable}
                    selected={this.state.permisoListSelected}
                    titleLeft="Disponibles"
                    titleRight="Asignados"
                    height="220px"
                    onAdd={(item) => this.handleAddButtonDoubleClick(
                      this.state.permisoListAvaiable.indexOf(item), item
                    )}
                    onRemove={(item) => this.handleRemoveButtonDoubleClick(
                      this.state.permisoListSelected.indexOf(item), item
                    )}
                  />

                  <div className="sso-modal-save-bar">
                    <MDBBtn onClick={(event) => this.doSave(event)}>
                      <MDBIcon fas icon="save" className="me-2" />
                      Guardar
                    </MDBBtn>
                  </div>
                </MDBContainer>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    );
  }
}
